import type React from 'react'
import { useEffect, useState } from 'react'

export const defaultScrollPos = 1500 // offscreen when ref has not loaded yet

export const useRevealOnPageScroll = (ref: React.RefObject<HTMLDivElement>): boolean => {
  const [showTransition, setShowTransition] = useState<boolean>(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = ref.current?.getBoundingClientRect().y ?? defaultScrollPos

      if (scrollPos < 0) {
        setShowTransition(true)
      } else {
        setShowTransition(false)
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [ref])

  return showTransition
}
